// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { TypographyProps } from "@insite/mobius/Typography";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { ellipsis } from "@tps/XDL/Utilities";
import { mergeWithCss } from "@tps/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

interface ProductDescriptionVariantStyles {
    small?: ProductDescriptionStyles;
    medium?: ProductDescriptionStyles;
}

const sharedStyles: { [key in keyof ProductDescriptionVariantStyles]: StyledProp } = {
    small: css`
        margin-bottom: 8px;
        align-items: flex-start;
        -webkit-box-align: start;
    `,
    medium: css`
        margin-bottom: 12px;
        align-items: flex-start;
        -webkit-box-align: start;
    `,
};
const sharedSmallTextStyles: TypographyProps = {
    size: 14,
    weight: "bold",
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 19px;
        vertical-align: unset;
        ${wrapInContainerStyles}
        ${ellipsis(3)}
    `,
};
const sharedMediumTextStyles: TypographyProps = {
    size: 24,
    weight: "bold",
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 32px;
        vertical-align: unset;
        ${wrapInContainerStyles}
        ${ellipsis(3)}
    `,
};

const productDescriptionVariantStyles: ProductDescriptionVariantStyles = {
    small: {
        productDetailDescription: {
            ...mergeWithCss(sharedSmallTextStyles, { css: sharedStyles.small }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedSmallTextStyles,
                    },
                    css: css`
                        width: auto;
                    `,
                },
                { css: sharedStyles.small },
            ),
        },
    },
    medium: {
        productDetailDescription: {
            ...mergeWithCss(sharedMediumTextStyles, { css: sharedStyles.medium }),
        },
        productDetailLink: {
            ...mergeWithCss(
                {
                    color: "text.main",
                    typographyProps: {
                        ...sharedMediumTextStyles,
                    },
                    css: css`
                        width: auto;
                    `,
                },
                { css: sharedStyles.medium },
            ),
        },
    },
};

export default productDescriptionVariantStyles;
